import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Observable} from "rxjs";
import {Category} from "../interfaces/category.interface";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  constructor(private http: HttpClient) { }

	index(
		filters: any, orderBy = '', order = 'asc',
		pageNumber = 0, pageSize = 5): Observable<any> {
		let params = new HttpParams();
		Object.keys(filters).forEach(function (key) {
			params = params.append(key, filters[key]);
		});
		params = params.append('order_by', orderBy);
		params = params.append('order', order);
		params = params.append('page', pageNumber);
		params = params.append('per_page', pageSize);
		return this.http.get(environment.apiUrl + '/categories', {
			params: params
		});
	}

	storeOrUpdate(categories: Category): Observable<Object> {
		return categories.id ? this.edit(categories) : this.store(categories);
	}

	store(categories: Category): Observable<Object> {
		return this.http.post(environment.apiUrl + '/categories', categories);
	}

	edit(categories: Category): Observable<Object> {
		return this.http.put(environment.apiUrl + '/categories/' + categories.id, categories);
	}
	destroy(id: number): Observable<Object> {
		return this.http.delete(environment.apiUrl + '/categories/' + id);
	}

	bulkDelete(ids: number[]): Observable<Object> {
		return this.http.patch(environment.apiUrl + '/categories/delete-multiple', {
			ids
		});
	}
}
